/* esm.sh - d3-transition@3.0.1/src/active */
export * from "/*d3-transition@3.0.1/esnext/src/active.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/active.mjs";
